import {
    AD_STATUS_EXPIRED,
    AD_STATUS_FORSALE,
    AD_STATUS_ON_HOLD,
    AD_STATUS_SOLD,
    AD_TYPE_FORRENT_EN,
} from './components/common_utils';

/* global listOwnAd */
export const adChangeStatus = {
    selectedOption: $('#ownAdChangeStatus .adStatus:checked').val(),
    adStatus: '',
    adType: '',
    dayNames: ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'],
    showChangeAdStatusModal(adId, adType, adStatus, soldThroughSite) {
        let params = `adId=${adId}&adType=${adType}&adStatus=${adStatus}&soldThroughSite=${soldThroughSite}`;
        $.get(Routing.generate('ad_status_show_option'), params, function (data) {
            window.$.colorbox({
                html: data.htmlContent,
            });

            return false;
        });
    },
    checkAdStatus(adStatus, selectedOption) {
        let $saveAndContinueButton = $('#ownAdChangeStatus .saveButton,#ownAdChangeStatus .continueButton');
        $saveAndContinueButton.removeAttr('disabled');
        if (selectedOption === adStatus) {
            $saveAndContinueButton.attr('disabled', 'disabled');
        }
    },
    // Check selected ad status and show/hide next step button
    selectedAdStatus(selectedOption, adStatus, adType) {
        $('#ownAdChangeStatus #soldOptions,#ownAdChangeStatus .continueButton').hide();
        let $saveButton = $('#ownAdChangeStatus .saveButton');
        $saveButton.attr('disabled', false).show();
        if (AD_STATUS_SOLD === selectedOption && AD_TYPE_FORRENT_EN !== adType) {
            $saveButton.hide();
            $('#ownAdChangeStatus .continueButton, #ownAdChangeStatus #soldOptions').show();
        }
        adChangeStatus.checkAdStatus(adStatus, selectedOption);
        window.$.colorbox.resize();
    },
    showFirstStep() {
        $('#ownAdChangeStatus .markAdExpiredMain,#ownAdChangeStatus .step2,#ownAdChangeStatus .forsaleStep2').hide();
        $('#ownAdChangeStatus .step1').show();
        window.$.colorbox.resize();
    },
    showRemoveFromSaleModal() {
        $('#ownAdChangeStatus .step1,#ownAdChangeStatus .step2,#ownAdChangeStatus .forsaleStep2').hide();
        $('#ownAdChangeStatus .markAdExpiredMain').show();
        window.$.colorbox.resize();
    },
    validateSoldAdPrice(form) {
        let soldPriceElement = $(form)[0].soldPrice;
        let soldPrice = soldPriceElement.value;
        // If Nettivene finn boat dealer permission set then price is mandatory
        let isFinnBoatDealer = $('#soldPrice').data('is-finn-boat-dealer') || '';

        if (!commonUtils.isEmpty(soldPrice) || isFinnBoatDealer) {
            if (!soldPrice.match(/^\d{1,10}$/)) {
                let message = isFinnBoatDealer
                    ? Translations.finnboat_price_mandatory
                    : Translations.ad_status_change.error.price;
                alert(message);
                soldPriceElement.focus();
                return false;
            }
            if (parseInt(soldPrice, 10) < 1) {
                alert(Translations.ad_status_change.error.less_price);
                soldPriceElement.focus();
                return false;
            }
        }

        $('#ownAdChangeStatus #soldButton').attr('disabled', true);
        return true;
    },
    markAdToHold(form) {
        let params = $(form).serialize();
        let newStatusValue = $(form)[0].newStatus.value;
        $.post(Routing.generate('ad_status_update'), params, function (data) {
            if (data.status === 'error') {
                alert(data.message);
                return;
            }

            commonUtils.showNotification(data.message);
            window.$.colorbox.close();
            // Redirect user to own ad page if not currently in own ad page
            if (-1 === window.location.href.indexOf(Routing.generate('own_ad_list'))) {
                window.location.href = Routing.generate('own_ad_list');
            } else {
                // Refresh own ad data
                listOwnAd.getAdData('change');
                $(`.${newStatusValue}StatusTab`).removeClass('none-imp');
                if (0 === $('#ownAdsListingMain .own-ads-list-card').length) {
                    $('#disabledLinkElement').addClass('disabled-all-links');
                }
            }
        });
    },
    getMonths() {
        let monthName = [];
        for (let i = 1; i <= 12; i++) {
            monthName.push(Translations.month_names[i]);
        }

        return monthName;
    },
    getDayShortNames() {
        let dayName = [];
        $.each(adChangeStatus.dayNames, function (key, value) {
            dayName.push(Translations.days[value]);
        });

        return dayName;
    },
    markAdToSold(form) {
        let params = $(form).serialize();
        let newStatusValue = $(form)[0].newStatus.value;
        $.post(Routing.generate('ad_status_update'), params, function (data) {
            if (data.status === 'error') {
                alert(data.message);
                return;
            }

            if (data.message) {
                window.$.colorbox({
                    href: '.soldMessagePopup',
                    inline: true,
                    onClosed() {
                        // Redirect user to own ad page if not currently in own ad page
                        if (-1 === window.location.href.indexOf(Routing.generate('own_ad_list'))) {
                            window.location.href = Routing.generate('own_ad_list');
                        } else {
                            // Refresh own ad data
                            listOwnAd.getAdData('change');
                            $(`.${newStatusValue}StatusTab`).removeClass('none-imp');
                        }
                    },
                });
            } else {
                window.$.colorbox.close();
                commonUtils.showNotification(data.message);
            }
        });
    },
    processAdStatusChange(selectedStatus) {
        let $saveButton = $('#ownAdChangeStatus .saveButton');
        switch (selectedStatus) {
            case AD_STATUS_FORSALE:
                if (commonUtils.isDealerLogin()) {
                    adChangeStatus.markAdToHold($('.adForsaleForm'));
                    $saveButton.attr('disabled', true);
                } else {
                    $('#ownAdChangeStatus .step1,#ownAdChangeStatus .step2').hide();
                    $('#ownAdChangeStatus .forsaleStep2').show();
                    window.$.colorbox.resize();
                }
                break;
            case AD_STATUS_SOLD: {
                let isRentAd = AD_TYPE_FORRENT_EN === adChangeStatus.adType;
                if (!isRentAd) {
                    $('#ownAdChangeStatus .step1,#ownAdChangeStatus .forsaleStep2').hide();
                    $('#ownAdChangeStatus .step2').show();
                    let minDate = new Date(Date.now() - 14 * 24 * 60 * 60 * 1000); // past 14 days date
                    let maxDate = new Date(Date.now() + 14 * 24 * 60 * 60 * 1000); // maximum 14 days from current date
                    $('#soldDate')
                        .datepicker({
                            firstDay: 1,
                            dateFormat: 'yy-mm-dd',
                            monthNames: adChangeStatus.getMonths(),
                            dayNamesMin: adChangeStatus.getDayShortNames(),
                            minDate,
                            maxDate,
                        })
                        .datepicker('setDate', 'now');
                    window.$.colorbox.resize();
                } else {
                    let isValid = isRentAd
                        ? true
                        : adChangeStatus.validateSoldAdPrice($('#ownAdChangeStatus .rentSoldForm'));
                    if (isValid) {
                        return adChangeStatus.markAdToSold($('.rentSoldForm'));
                    }
                }
                break;
            }
            case AD_STATUS_ON_HOLD:
            case AD_STATUS_EXPIRED:
                adChangeStatus.markAdToHold($('.adHoldForm'));
                $saveButton.attr('disabled', true);
                break;
            default:
                break;
        }
        return undefined;
    },
};

$(function () {
    let $body = $('body');

    // Show ad change status modal from own ad page
    $body.on('click', '.changeOwnAdStatus', function () {
        let adId = $(this).data('ad-id');
        let adType = $(this).data('ad-type');
        let adStatus = $(this).data('ad-status');
        let soldThroughSite = $(this).data('sold-through-site') || '';
        let activePromotion = $(this).data('promotion-active') || '';

        if ('Y' === activePromotion) {
            let isShowcaseActivePromotion = $(this).data('promotion-showcase');
            let isFastlaneActivePromotion = $(this).data('promotion-fastlane');
            let message = '';
            if (isShowcaseActivePromotion && isFastlaneActivePromotion) {
                message = Translations.ad_status_change.upsell_showcase_warning;
            } else if (isShowcaseActivePromotion) {
                message = Translations.ad_status_change.showcase_warning;
            } else if (isFastlaneActivePromotion) {
                message = Translations.ad_status_change.upsell_warning;
            }

            if (!confirm(message)) {
                return false;
            }
        }

        adChangeStatus.showChangeAdStatusModal(adId, adType, adStatus, soldThroughSite);
        return undefined;
    });

    // Show/hide modal as per selected ad status
    $body.on('click', '#ownAdChangeStatus .adStatus', function () {
        adChangeStatus.selectedOption = $(this).val();
        adChangeStatus.selectedAdStatus(adChangeStatus.selectedOption, adChangeStatus.adStatus, adChangeStatus.adType);
    });

    // Remove ad from sale for seller
    $body.on('click', '#ownAdChangeStatus .removeFromSaleButton', function () {
        $(this).attr('disabled', true);
        adChangeStatus.markAdToHold($('.removeSaleForm'));
    });

    // Check/uncheck sold through site checkbox
    $body.on('click', '#ownAdChangeStatus #soldThroughSite', function () {
        $('#ownAdChangeStatus #howSold').val(this.checked ? 'Y' : 'N');
    });

    // Take user to first step from step 2 when changing to sold/remove from sale
    $body.on('click', '.showFirstStep', function () {
        adChangeStatus.showFirstStep();
    });

    // Show remove ad from sale modal
    $body.on('click', '.showRemoveFromSaleModal', function () {
        adChangeStatus.showRemoveFromSaleModal();
    });

    // Save ad status to sold from sold modal
    $body.on('click', '#soldButton', function () {
        if (adChangeStatus.validateSoldAdPrice($('#ownAdChangeStatus .adSoldForm'))) {
            adChangeStatus.markAdToSold($('.adSoldForm'));
            return false;
        }
        return undefined;
    });

    // Process ad status as per new status
    $body.on('click', '#ownAdChangeStatus .saveButton, #ownAdChangeStatus .continueButton', function () {
        adChangeStatus.processAdStatusChange(adChangeStatus.selectedOption);
    });
});

global.adChangeStatus = adChangeStatus;
